import { useLocationStore as useLocationStoreLegacy } from '@global-store/stores/location'
import { stripTrailingSlash } from '@internal/url'
import { useLocationStore } from '@shared/global-store/stores/location/location'

const contentfulImage = (
  obj: any,
  width: number | null = null,
  height: number | null = null
) => {
  const imageMaxWidth = 2000

  if (obj === null) return ''

  const url =
    obj.fields?.file?.url !== undefined ? obj.fields.file.url : obj.toString()

  const params = []

  width !== null
    ? params.push(`w=${width.toString()}`)
    : params.push(`w=${imageMaxWidth.toString()}`)

  height !== null ? params.push(`h=${height.toString()}`) : null

  return `${url}?${params.join('&')}`
}

const contentfulUrl = (path: string | null | undefined) => {
  const locationStoreLegacy = useLocationStoreLegacy()
  const locationStore = useLocationStore()

  // for paths with old urlPrefixes included fetched from contentful
  // TODO: for next brands, we should use centralized location function with isShopify support
  const urlPrefixToShopify = {
    'de-de': 'de',
    'eu-en': 'en',
    'fr-fr': 'fr',
    'it-it': 'it',
    'es-es': 'es',
    'dk-da': 'dk',
  }

  const urlPrefix = !locationStoreLegacy.isShopify
    ? locationStoreLegacy.currentUrlPrefix
    : locationStore.urlPrefix.urlPrefix

  if (!path) return

  path = stripTrailingSlash(path)

  if (path.indexOf('http') === 0 || path.indexOf('https') === 0) {
    return path
  }

  if (path[0] === '#') {
    return path
  }

  if (path.charAt(0) === '/') {
    path = path.substring(1)
  }

  if (path.split('/')[0] === urlPrefix) {
    path = path.replace(`${urlPrefix}/`, '')
  }

  // for paths with old urlPrefixes included in contentful
  if (
    path.split('/')[0] ===
      urlPrefixToShopify[urlPrefix as keyof typeof urlPrefixToShopify] &&
    locationStoreLegacy.isShopify
  ) {
    path = path.replace(
      `${urlPrefixToShopify[urlPrefix as keyof typeof urlPrefixToShopify]}/`,
      ''
    )
  }

  if (locationStoreLegacy.isShopify && !path.endsWith('/')) {
    path = `${path}/`
  }

  if (locationStoreLegacy.location.host.includes('.de')) {
    return `/${path}`
  }

  return `/${urlPrefix}/${path}`
}

export { contentfulImage, contentfulUrl }
